import { createNavigation } from 'next-intl/navigation'
import type { ComponentProps } from 'react'
import { routing } from '@/i18n/routing'

export const { Link, redirect, usePathname, useRouter } = createNavigation(routing)

export type LinkProps = ComponentProps<typeof Link>
